var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',{attrs:{"name":"additional-portal-for-filter","multiple":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }